import { render, staticRenderFns } from "./FullScreenModal.vue?vue&type=template&id=6b33fb2a&scoped=true&"
import script from "./FullScreenModal.vue?vue&type=script&lang=js&"
export * from "./FullScreenModal.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenModal.vue?vue&type=style&index=0&id=6b33fb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33fb2a",
  null
  
)

component.options.__file = "FullScreenModal.vue"
export default component.exports